/* created by CoolGuy on 2018/11/27 */
import React from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import { fixIosFocusProblem } from '../../utils/dom';
import intl from 'react-intl-universal';

import './index.scss';

const OneRow = (props) => {
  return (
    <div className={'red-pack-row'} style={props.style}>
      <div className="row-left">{props.left}</div>
      {props.center}
      <div className="row-right">{props.right}</div>
    </div>
  );
};
const MAX_SINGLE_MONEY = 200; // 单个红包的最大值，微信要求
const MIN_SINGLE_MONEY = 1; // 目前即享是这个情况
@inject('rootStore')
@observer
class SendPack extends React.Component {
  @observable type = 'luck'; // 拼手气红包 和定额红包
  @observable money = '';
  @observable number = '';
  @observable textarea = '';
  @action toggleTip = () => {
    this.showTip = !this.showTip;
  };
  @action switchType = (type) => {
    if (type && typeof type === 'string') {
      this.type = type;
    } else {
      this.type = this.type === 'normal' ? 'luck' : 'normal';
    }
  };
  @action toSwitchType = () => {
    // 从normal切换到luck
    if (this.type === 'normal') {
      this.switchType('luck');
      this.money *= this.floorNumber;
    } else {
      this.switchType('normal');
      this.money /= this.floorNumber;
    }
  };
  @computed get singleMoney() {
    //单个红包的金额
    const { type, money } = this;
    if (type === 'normal') {
      return +money;
    } else {
      return +money / this.floorNumber;
    }
  }
  @computed get tipContent() {
    if (this.totalMoney * 1 > MAX_SINGLE_MONEY) {
      return '红包总金额最多200元';
    }
    // if(this.singleMoney > MAX_SINGLE_MONEY){
    //     return '单个红包金额不超过200元';
    // }
    // if(this.totalMoney !== '0.00' && this.totalMoney < 1){
    //     return '红包总额至少为1元'
    // }
    console.log(this.singleMoney, MIN_SINGLE_MONEY);
    if (this.singleMoney < MIN_SINGLE_MONEY && this.singleMoney !== 0) {
      return '单个红包金额至少' + MIN_SINGLE_MONEY + '元';
    }
    return '';
  }

  componentDidMount() {
    // document.title = '即享影像';
    // WxUtil.configShare(null, ()=>{
    //
    // });
  }

  setSth = (key) => {
    return action((e) => {
      const { value } = e.target;
      let flag = true; // 是否最终赋值
      if (key === 'number') {
        //number 只能是纯数字
        if (value === '') {
          flag = true;
          // 不允许0
        } else if (/^\d{1,5}$/g.test(value) && +value !== 0) {
          flag = true;
        } else {
          flag = false;
        }
      }
      if (flag) {
        this[key] = value;
      }
    });
  };
  @computed get typeLongName() {
    return this.getTypeName(this.type);
  }
  getTypeName = (type) => {
    switch (type) {
      case 'normal':
        return intl.get('Identical Amount');
      case 'luck':
        return intl.get('Random Amount');
      default:
        return '';
    }
  };
  // int后的值，如果转换失败（比如不是数字之类的，返回1）
  @computed get floorNumber() {
    const { number } = this;
    let fNumber = parseInt(number, 10);
    return isNaN(fNumber) ? 1 : fNumber;
  }
  @computed get totalMoney() {
    const { money, type } = this;
    if (isNaN(+money)) {
      return '0.00';
    }
    if (type === 'luck') {
      return (+money).toFixed(2);
    }
    // normal 是相乘
    return (+money * (this.floorNumber || 1)).toFixed(2);
  }
  // @computed get typeShortName(){
  //     switch (this.type) {
  //         case 'luck': return '拼';
  //         default: return '';
  //     }
  // }
  closeModal = () => {
    let { rootStore } = this.props;
    rootStore.redPackStore.setSendModal(false);
  };

  // 防止重复点击，因为不知道这个协议要多少时间，不用debounce，用这种方式比较保险
  // sendRedPackBtnEnable = true;
  sendRedPackBtnEnable = true;
  sendRedPack = () => {
    let _this = this;
    const amount = parseInt(this.totalMoney * 100, 10);
    if (this.totalMoney > MAX_SINGLE_MONEY) {
      return false;
    }
    if (this.singleMoney > MAX_SINGLE_MONEY) {
      return false;
    }
    if (this.singleMoney < MIN_SINGLE_MONEY) {
      return false;
    }
    console.warn('prepare to pay');
    const { redPackStore, uiStore } = this.props.rootStore;
    if (!window.wx) {
      // 正常情况下，在非微信浏览器根本看不到这个组件，也无从看到这个弹框，所以不国际化了
      uiStore.showAlert('请在微信浏览器中打开');
      return;
    }
    if (this.sendRedPackBtnEnable === false) {
      console.log('点击太快了，不接受你的点击');
      return;
    }
    this.sendRedPackBtnEnable = false;
    redPackStore
      .preCreate({
        amount: amount,
        galleryid: window.gallery.id,
      })
      .then((result) => {
        console.log(result);
        this.sendRedPackBtnEnable = true;
        if (result.success) {
          let { tradeid, wxpay } = result.data;

          var payPost = {
            timestamp: wxpay.timeStamp,
            nonceStr: wxpay.nonceStr,
            signType: wxpay.signType,
            paySign: wxpay.paySign,
            package: wxpay.package,
            success: (res) => {
              _this.sendContentPack(tradeid, res);
            },
          };
          window.wx.chooseWXPay(payPost);
          // _this.sendContentPack(tradeid, {
          //     errMsg:'chooseWXPay:ok'
          // });
        }
      });
  };

  sendContentPack = (tradeid, res) => {
    console.log('sendcontentpack', tradeid, res);
    let _this = this;
    const { redPackStore, uiStore, commentStore } = this.props.rootStore;
    if (res && res.errMsg == 'chooseWXPay:ok') {
      // 此处要调用发红包接口了
      // 后端支付有个回调处理时间，就延迟个300ms再调用接口吧
      setTimeout(() => {
        const amount = parseInt(_this.totalMoney * 100, 10);
        const number = _this.number * 1 || 1;
        const content = _this.textarea || intl.get('Best wishes');
        const type = _this.type;
        const galleryid = window.gallery.id;
        redPackStore
          .create({
            amount,
            number,
            content,
            type,
            tradeid,
            galleryid,
          })
          .then((res) => {
            if (res && res.success) {
              //alert('发送成功');
              uiStore.showToast({
                time: 500,
                content: intl.get('Send succeed'),
              });
              // 发送成功之后需要更新 好多数据
              // commentStore.getMyList(galleryid);
              commentStore.clear(); //主要是清空lastTime，否则获取的列表上是基于上一次时间之后的数据，这可能没有包括红包
              commentStore.getList(galleryid);
              redPackStore.getServerTime().then(() => {
                redPackStore.getDetail();
              });
              this.closeModal();
            } else {
              uiStore.showAlert(res.message);
              // alert(res.message);
            }
          });
      }, 300);
    } else {
      // alert(res.errMsg);
      uiStore.showAlert(res.errMsg);
    }
  };

  renderRedPackType = () => {
    return (
      <div className="red-pack-type">
        {this.type === 'luck' && (
          <>
            <div className={'red-pack-type-word'}>拼</div>
            {intl.get('Total')}
          </>
        )}
        {this.type === 'normal' && <>{intl.get('Amount Each')}</>}
      </div>
    );
  };

  render() {
    const loc = intl.getInitOptions().currentLocale;
    return (
      <div className="send-pack" style={this.props.style}>
        <img
          src={require('../../assets/x-36.png')}
          className={'x-36'}
          onClick={this.closeModal}
          alt=""
        />
        {this.tipContent && (
          <div className="top-tip">
            {this.tipContent}
            {/*<img src={require("../../assets/redpack/redpack-x.png")} className="close" alt="" onClick={this.toggleTip} />*/}
          </div>
        )}
        <div style={{ fontSize: 18, margin: 20, textAlign: 'center' }}>
          {this.typeLongName}
        </div>
        <OneRow
          left={this.renderRedPackType()}
          center={
            <input
              className={'the-input'}
              placeholder={'0.00'}
              step={0.01}
              type="number"
              onChange={this.setSth('money')}
              onBlur={fixIosFocusProblem}
              value={this.money}
            />
          }
          right={intl.get('CNY')}
        />
        <div style={{ marginTop: 8, marginBottom: 8 }}>
          {intl.get('Current is ')}
          {this.typeLongName},
          <span className={'change-type'} onClick={this.toSwitchType}>
            {intl.get('Change to ')}
            {this.getTypeName(this.type === 'normal' ? 'luck' : 'normal')}
          </span>
        </div>
        <OneRow
          left={intl.get('Quantity')}
          // 比较奇怪，如果type="number" 可以输入小数点进去，不受this.number控制的感觉,但是毕竟这个能吊起数字键盘，先这样吧
          center={
            <input
              className={'the-input'}
              placeholder={intl.get('Enter number')}
              type="number"
              step={1}
              onChange={this.setSth('number')}
              onBlur={fixIosFocusProblem}
              value={this.number}
            />
          }
          right={loc === 'zh-CN' ? '个' : ''}
        />
        <textarea
          placeholder={intl.get('Best wishes')}
          className={'red-pack-row red-pack-textarea'}
          onChange={this.setSth('textarea')}
          onBlur={fixIosFocusProblem}
          value={this.textarea}
        />
        <div className="the-price">
          <span className={'rmb'}>￥</span>
          {this.totalMoney}
        </div>
        <button className="big-btn" onClick={this.sendRedPack}>
          {intl.get('Prepare Red Packet')}
        </button>
        <div className="bottom">
          {intl.get('Unclaimed red packet will be refund after 24 hours')}
        </div>
      </div>
    );
  }
}

export default SendPack;
